class UserAgentWarningTask {
    static async run({env}) {
        if (env.isMobile()) {
            await env.showDialog('mobile-warning-dialog');
        }
        else if (env.isSmallDesktopScreen()) {
            await env.showDialog('small-screen-dialog');
        }
        else if (env.isSmallDesktopBrowser()) {
            await env.showDialog('small-browser-dialog');
        }
    }
}

export default UserAgentWarningTask;